'use client'

import { useEffect, useRef } from 'react'
import { trackVisitApi } from '@/lib/commerce/services/visit-api'

export function useVisitTracking(vendor: any) {
  const trackedVendorIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (!vendor?.id) return
    if (trackedVendorIdRef.current === vendor.id) return
    trackedVendorIdRef.current = vendor.id
    trackVisitApi(vendor.id).catch(() => {})
  }, [vendor?.id])
}
